import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import FoodProfileInfo from 'apps/foodProfile/containers/FoodProfileInfo';

export default class BopFoodProfileBasicInfo extends PureComponent {
  static propTypes = {
    barcode: PropTypes.string,
  };

  render() {
    const {
      isBadgeEnabled,
      productsSuitability,
      barcode,
    } = this.props;
    const productSuitability = productsSuitability[barcode] || {};

    if (!isBadgeEnabled || productSuitability.isSuitable !== 0) return null;

    return (
      <div className="bop-foodProfileBasicInfo">
        <div className="gn-divider gn-divider--light" />
        <div className="gn-card">
          <FoodProfileInfo barcode={barcode} />
        </div>
      </div>
    );
  }
}
